import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ScheduledMessageCard from "./ScheduledMessageCard";
import Chip from '@mui/material/Chip';
import {axiosInstance} from "../utils/axiosUtils";
import {useState} from "react";
import Button from "@mui/material/Button";
import {Stack, Badge} from "@mui/material";
import WomanIcon from '@mui/icons-material/Woman';
import ManIcon from '@mui/icons-material/Man';


export default function Customer({customer, scheduledMessageWithActionLog, changed, deleted, overridePhoneNumber, templates, updateCustomersData}) {
    const SyncCustomer = async () => {
        const response  = await axiosInstance.get('/Whatsapp/Sync/' + customer.id);
        updateCustomersData(response.data);
    }
    const isMale = customer.tagsArray.find((tag)=> tag.trim() === 'male');
    const isFemale = customer.tagsArray.find((tag)=> tag.trim() === 'female');
    return (
        <Card raised sx={{marginTop: '20px'}}>
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    {customer.first_name} {customer.last_name}
                    {isFemale && <WomanIcon color={"warning"}/>}
                    {isMale && <ManIcon/>}

                </Typography>
                <Typography variant="body" color="text.secondary">
                    <Stack direction="row" spacing={16}>
                        {customer.phone && <Chip label={customer.phone}/>}
                        {changed ? <Badge badgeContent={1} color="success">
                            <Button onClick={SyncCustomer} variant="contained">סנכרן</Button>
                        </Badge> : <Button onClick={SyncCustomer} variant="contained">סנכרן</Button>
                        }
                        {deleted && <Badge badgeContent={1} color="error">
                            <Button onClick={()=>console.log("רענן")} variant="contained">רענן</Button>
                        </Badge>}
                    </Stack>
                </Typography>
                {scheduledMessageWithActionLog && scheduledMessageWithActionLog.filter(item=>!item.hide).map((item, index) => (
                    <div key={index}>
                        <ScheduledMessageCard phoneNumber={customer.phone} SyncCustomer={()=>SyncCustomer(customer.id)} scheduledMessage={item} expand={false} overridePhoneNumber={overridePhoneNumber} templates={templates}/>
                    </div>
                ))
                }
            </CardContent>
        </Card>
    );
}
